import { Trans } from "@lingui/react/macro";

import { useCurrentUser } from "../api/useCurrentUser";

// Заголовок главной: «Привет, <ник из Steam>». Ника нет — просто «Привет!».
export const Greeting = () => {
  const { data: user } = useCurrentUser();
  const name = user?.display_name ?? null;
  return (
    <h1 className="font-display text-[34px] leading-[1.15]">
      {name === null ? <Trans>Hi!</Trans> : <Trans>Hi, {name}</Trans>}
    </h1>
  );
};
